import { render, staticRenderFns } from "./Validacao2fa.vue?vue&type=template&id=3917c220&scoped=true"
import script from "./Validacao2fa.vue?vue&type=script&lang=js"
export * from "./Validacao2fa.vue?vue&type=script&lang=js"
import style0 from "./Validacao2fa.vue?vue&type=style&index=0&id=3917c220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3917c220",
  null
  
)

export default component.exports